import { openDatabase as baseOpenDatabase, closeDatabase, getDocumentDbName, globalIDB, storeRequestPromise, } from '../../util.js';
/**
 * Upgrades the database to the given version, using the given upgrader function.
 */
export async function upgradeDatabase(indexedDb, namespace, version, upgrader, log) {
    log === null || log === void 0 ? void 0 : log('debug', 'Upgrading database', namespace, 'to version', version);
    function openAndUpgrade(resolve, reject) {
        const request = indexedDb.open(getDocumentDbName(namespace), version);
        let wasUpgraded = false;
        request.onupgradeneeded = (event) => {
            const transaction = request.transaction;
            upgrader(transaction, request.result, event);
            wasUpgraded = true;
        };
        request.onsuccess = async (event) => {
            if (wasUpgraded) {
                // close the database
                await closeDatabase(request.result);
                resolve(request.result);
            }
            else {
                reject(new Error('Database was not upgraded when a version change was expected'));
            }
        };
        request.onerror = (event) => {
            reject(request.error || new Error('Unknown error'));
        };
        request.onblocked = (event) => {
            log === null || log === void 0 ? void 0 : log('Database upgrade blocked!');
        };
    }
    return new Promise(openAndUpgrade);
}
export async function openDatabase({ indexedDB = globalIDB, namespace, version, log, }) {
    log === null || log === void 0 ? void 0 : log('debug', 'Opening database', namespace, 'at version', version);
    const db = await baseOpenDatabase(getDocumentDbName(namespace), version, indexedDB);
    db.addEventListener('versionchange', (event) => {
        db.close();
    });
    db.addEventListener('close', () => {
        log === null || log === void 0 ? void 0 : log('warn', 'Database closed', namespace);
    });
    return db;
}
export async function copyAll(sourceDatabase, targetDatabase) {
    // DOMStringList... doesn't have iterable... why
    const sourceStoreNames = new Array();
    for (let i = 0; i < sourceDatabase.objectStoreNames.length; i++) {
        sourceStoreNames.push(sourceDatabase.objectStoreNames[i]);
    }
    const copyFromTransaction = sourceDatabase.transaction(sourceStoreNames, 'readonly');
    const copyFromStores = sourceStoreNames.map((name) => copyFromTransaction.objectStore(name));
    const allObjects = await Promise.all(copyFromStores.map((store) => storeRequestPromise(store.getAll())));
    const copyToTransaction = targetDatabase.transaction(sourceStoreNames, 'readwrite');
    const copyToStores = sourceStoreNames.map((name) => copyToTransaction.objectStore(name));
    for (let i = 0; i < copyToStores.length; i++) {
        await Promise.all(allObjects[i].map((obj) => {
            return storeRequestPromise(copyToStores[i].put(obj));
        }));
    }
}
//# sourceMappingURL=db.js.map